import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { catalogBibShape, libraryShape, paginationShape } from '@bibliocommons/bc-prop-types';
import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';
import { selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import StackMapActions from 'app/actions/StackMapActions';
import { trackHoldingsWayfinderView as trackHoldingsWayfinderViewAction } from 'app/actions/AnalyticsGa4Actions';
import { UI_COMPONENT_TYPE, METADATA_CATEGORY_TYPE, UI_CONTAINER_TYPE } from 'app/constants/AnalyticsGa4Constants';

import StackMapLink from './StackMapLink';

export class StackMapLinkContainer extends React.PureComponent {
  trackShelfMapClick = shelfMapText => {
    const {
      bibItem,
      catalogBib,
      currentView,
      pagination,
      sortBys,
      trackHoldingsWayfinderView,
      itemPosition,
      itemPositionGrouped,
      totalCount
    } = this.props;
    const isFromSearchPage = window?.location?.pathname === '/v2/search';

    // Note: `catalogBib` will be in Redux state only when this component is rendered on the Bib Page.
    trackHoldingsWayfinderView({
      bibId: catalogBib?.get('metadataId'),
      ui: {
        ui_component_type: UI_COMPONENT_TYPE.LINK_TEXT,
        ui_component_label: shelfMapText,
        ...(isFromSearchPage && {
          ui_content_position: itemPosition,
          ui_content_position_grouped: itemPositionGrouped,
          ui_content_position_grouped_count: totalCount,
          ui_container_type: UI_CONTAINER_TYPE.ITEM,
          ui_content_layout: currentView,
          ui_content_page: pagination.get('page'),
          ui_content_sort: sortBys.find(sortBy => sortBy.get('applied'))?.get('id'),
          ui_content_total_count: pagination.get('count')
        })
      },
      metadata: {
        metadata_category_type: METADATA_CATEGORY_TYPE.HOLDINGS_RESOURCE_ITEM_ID,
        metadata_value: bibItem.get('itemId')
      },
      location: {
        location_id: bibItem.getIn(['branch', 'code']),
        location_name: bibItem.getIn(['branch', 'name'])
      }
    });
  };

  render() {
    return <StackMapLink {...this.props} trackShelfMapClick={this.trackShelfMapClick} />;
  }
}

StackMapLinkContainer.propTypes = {
  bibItem: ImmutablePropTypes.map.isRequired,
  catalogBib: catalogBibShape,
  currentLibrary: libraryShape.isRequired,
  currentView: PropTypes.string,
  itemPosition: PropTypes.number,
  itemPositionGrouped: PropTypes.number,
  totalCount: PropTypes.number,
  pagination: paginationShape,
  sortBys: ImmutablePropTypes.listOf(
    ImmutablePropTypes.mapContains({
      id: PropTypes.string.isRequired,
      applied: PropTypes.bool
    })
  ),
  stackMapActions: PropTypes.objectOf(PropTypes.func).isRequired,
  handleClick: PropTypes.func,
  trackHoldingsWayfinderView: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  catalogBib: selectCatalogBib(state),
  currentView: state.getIn(['search', 'catalogSearch', 'view']),
  currentLibrary: selectCurrentLibrary(state),
  pagination: state.getIn(['search', 'catalogSearch', 'pagination']),
  sortBys: state.getIn(['search', 'catalogSearch', 'sortBys'])
});

const mapDispatchToProps = dispatch => ({
  stackMapActions: bindActionCreators(StackMapActions, dispatch),
  trackHoldingsWayfinderView: bindActionCreators(trackHoldingsWayfinderViewAction, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(StackMapLinkContainer));
